
import { Button } from "@/components/ui/button";
import { ArrowRight, Users } from "lucide-react";

const HeaderSection = () => {
  return (
    <div className="mb-10">
      <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-2 animate-fade-in">
        Youth Basketball Training in Charlotte, NC
      </h1>
      <h2 className="text-xl sm:text-2xl md:text-3xl text-gray-700 mb-4 sm:mb-6 animate-fade-in" style={{ animationDelay: "200ms" }}>
        All-Star Basketball and Physical Education Academy
      </h2>
      <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-8 max-w-3xl mx-auto animate-fade-in" style={{ animationDelay: "300ms" }}>
        Professional basketball training for youth, kids, teens, collegiate, and pro players in Charlotte, North Carolina. 
        Our expert coaching with Dr. Kevin Butler delivers a 97% success rate. Join our basketball academy and elevate your game today!
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in" style={{ animationDelay: "600ms" }}>
        <Button 
          className="bg-primary hover:bg-primary/90 text-white rounded-full px-6 sm:px-8 py-5 sm:py-6 font-semibold text-sm sm:text-lg"
          onClick={() => {
            const trainingScheduleSection = document.querySelector('.training-schedule');
            if (trainingScheduleSection) {
              trainingScheduleSection.scrollIntoView({ behavior: 'smooth' });
            }
          }}
        >
          Start Basketball Training <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
        </Button>
        <Button 
          className="bg-secondary hover:bg-secondary/90 text-secondary-foreground rounded-full px-6 sm:px-8 py-5 sm:py-6 font-semibold text-sm sm:text-lg"
          onClick={() => {
            window.location.href = '/accomplishments';
          }}
        >
          Global Diversity and Inclusion Clause <Users className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
        </Button>
      </div>
    </div>
  );
};

export default HeaderSection;
